import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookPatternFormatNumberInputWrapper } from 'src/components/CookbookPatternFormatNumberInputWrapper/CookbookPatternFormatNumberInputWrapper';

export interface IPhoneNumberInputProps {
  name: string;
  id: string;
  label?: string;
  rules?: RegisterOptions;
}

export const BasePhoneNumberInput: React.FC<IPhoneNumberInputProps> = ({
  name,
  id,
  label = 'Phone',
  rules = {},
}) => {
  const { errors, control } = useFormContext();

  const defaultRules: RegisterOptions = {
    pattern: {
      value: /\(\d{3}\)\s\d{3}-\d{4}/,
      message: 'Phone number is invalid',
    },
    ...rules,
  };

  return (
    <CookbookPatternFormatNumberInputWrapper
      label={label}
      format="(###) ###-####"
      placeholder="(___) ___-____"
      id={id}
      name={name}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      rules={defaultRules}
    />
  );
};
